import { createFileRoute } from '@tanstack/react-router'

import { ContactStep } from '@/features/drives/contact-step'
import { handoverGate } from '@/features/handover/gate'

/** Step 3 of the hand-over, at `/bookings/{id}/contact`: the contact details the agreement is emailed to. */
export const Route = createFileRoute('/_app/bookings/$bookingId_/contact')({
  ...handoverGate(),
  component: ContactStep,
})
